<template>
  <v-container>
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>
    <v-card>
      <v-card-title>
        <v-container style="padding-left: 0px !important">
          <v-card
            style="
              border: 1px var(--secondary-color) solid;
              margin-bottom: 15px;
            "
          >
            <v-flex>
              <v-flex
                style="background-color: var(--secondary-color); padding: 10px"
              >
                <label style="color: white; font-weight: 600; font-size: 20px"
                  >Filtros</label
                >
              </v-flex>
            </v-flex>
            <v-flex class="form-group form-row px-3 mb-2">
              <v-flex class="col-sm-12 col-md-12 mb-1">
                <v-text-field
                  placeholder="Buscar por nome..."
                  v-model="search"
                ></v-text-field>
              </v-flex>
            </v-flex>
          </v-card>
          <v-flex>
            <v-row>
              <v-col cols="6">
                <button
                  type="button"
                  class="btn-block btn btn-primary mb-2 new-driver-button"
                  @click="openDialogPayment()"
                >
                  Capturar pagamento
                </button>
              </v-col>
              <v-col cols="6">
                <button
                  type="button"
                  class="btn-block btn btn-primary mb-2 new-driver-button"
                  @click="openDialogCancelAuthorization()"
                >
                  Cancelar Autorização Sem Transação
                </button>
              </v-col>
            </v-row>
          </v-flex>
        </v-container>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex xs3>
            <v-dialog
              ref="dialog_begin"
              v-model="modal_begin"
              :return-value.sync="begin_date"
              persistent
              lazy
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="begin_date"
                  label="Data inicio"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>

              <v-date-picker v-model="begin_date" scrollable class="color">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal_begin = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog_begin.save(begin_date)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs3>
            <v-dialog
              ref="dialog_end"
              v-model="modal_end"
              :return-value.sync="end_date"
              persistent
              lazy
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="end_date"
                  label="Data fim"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>

              <v-date-picker v-model="end_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal_end = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog_end.save(end_date)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs2>
            <v-btn
              class="btn-block btn btn-primary mb-2 filtro-button"
              @click="filtrar()"
              >Filtrar</v-btn
            >
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex offset-xs10>
            <download-excel
              class="ml-auto mr-0"
              :data="data"
              :fields="json_fields"
              name="pagamentos.xls"
            >
              <v-btn small class="mr-4"
                ><span class="pr-1">Exportar</span
                ><v-icon small class="black--text"
                  >insert_drive_file</v-icon
                ></v-btn
              >
            </download-excel>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-data-table
          footer-props.items-per-page-text="Linhas por página"
          :headers="headers"
          :items="data"
          :search="search"
          class="table-custom-vue elevation-1 mt-2"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.transaction_id }}</td>
              <td class>{{ item.vr_id }}</td>
              <td class>{{ item.client_name }}</td>
              <td class>{{ item.user_name }}</td>
              <td class>{{ item.type }}</td>
              <td class>{{ item.status }}</td>
              <td class>R$ {{ item.valor_pre_autorizado }}</td>
              <td class>R$ {{ item.total_value_charged }}</td>
              <td class>{{ item.pre_authorization_date | formatDate }}</td>
              <td class>{{ item.data_captura | formatDate }}</td>
              <td class="layout">
                <ActionButton
                  message="Estornar pagamento"
                  icon="mdi-cash-refund"
                  @onclick="refundPayment(item)"
                />
                <ActionButton
                  v-if="item.status == 'pending'"
                  message="Diálogo de pré-autorização"
                  icon="mdi-cash-multiple"
                  @onclick="openDialogPreAuthorization(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="dialogPayment" persistent max-width="400px">
        <v-card>
          <v-card-title>
            <span class="headline">Captura Manual de Valores</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md style="padding: 12px 0 0 0">
              <v-layout wrap>
                <v-flex sm12>
                  <label for="client">Cliente:</label>
                  <v-autocomplete
                    class="payment-autocomplete"
                    v-model="pagamento.clientId"
                    :items="clients"
                    item-text="text"
                    item-value="value"
                    solo
                    dense
                    required
                    @change="getUsersByClient()"
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm12>
                  <label for="user">Usuario:</label>
                  <v-autocomplete
                    class="payment-autocomplete"
                    v-model="pagamento.userId"
                    :items="users"
                    item-text="text"
                    item-value="value"
                    solo
                    dense
                    required
                    @change="getCardByUser()"
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm12>
                  <label for="card">Cartão:</label>
                  <select
                    class="form-control"
                    name="card"
                    v-model="pagamento.creditCardId"
                    required
                  >
                    <option
                      v-for="(creditCard, index) in creditCards"
                      :key="index"
                      :value="creditCard.id"
                    >
                      {{ creditCard.nickname }}
                    </option>
                  </select>
                </v-flex>
                <v-flex sm12>
                  <label for="user">Tipo de Captura:</label>
                  <v-autocomplete
                    class="payment-autocomplete"
                    v-model="pagamento.transactionType"
                    :items="transactionTypes"
                    item-text="text"
                    item-value="value"
                    solo
                    dense
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm12>
                  <label>Valor da captura</label>
                  <money
                    v-model="pagamento.amount"
                    v-bind="money"
                    class="form-control"
                  ></money>
                </v-flex>
                <v-flex sm12>
                  <v-text-field
                    label="Número de Parcelas"
                    v-model="pagamento.installments"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex sm12>
                  <v-text-field
                    label="Motivo da Captura"
                    v-model="pagamento.observation"
                    :disabled="validateObservationField()"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex sm12>
                  <v-text-field
                    label="Id da reserva"
                    v-model="pagamento.reservaId"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cleanFormPayment()"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="capturarPagamento()"
              >Capturar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog
        v-model="dialogCancelAuthorization"
        persistent
        max-width="400px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Cancelar Autorização Sem Transação</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex sm12>
                  <v-text-field
                    label="Cielo Payment ID"
                    v-model="cancelAuthorization.payment_cielo_id"
                    :disabled="validateObservationField()"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="cleanFormCancelAuthorization()"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="cancelarAutorizacao()"
              >Capturar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <RefundPayment
        :showModal="refund_payment_modal"
        :transaction="transaction"
        @refundFinish="refundFinish()"
        @close="refund_payment_modal = false"
      ></RefundPayment>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="dialogPreAuthorization" persistent max-width="400px">
        <v-card>
          <v-card-title>
            <span class="headline">Reserva: {{ vehicle_request_id }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex sm12>
                  <label>Valor da captura</label>
                  <money
                    v-model="preAuthorizationValue"
                    v-bind="money"
                    class="form-control"
                  ></money>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialogPreAuthorization = false"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="capturePreAuthorization()"
              >Capturar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import PaymentController from '../../controllers/PaymentController.js';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import ClientController from '../../controllers/ClientController';
import UserController from '../../controllers/UserController';
import UserCreditCardController from '../../controllers/UserCreditCardController';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import moment from 'moment';
import RefundPayment from '../shared/RefundPayment';
import ActionButton from '../shared/ActionButtonsTemplate';

export default {
  components: {
    ActionButton,
    RefundPayment,
  },
  async created() {
    await this.getReport(this.begin_date, this.end_date);
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      transaction: {},
      pagamento: {
        installments: 1,
      },
      cancelAuthorization: {},
      clients: [],
      users: [],
      transactionTypes: [],
      creditCards: [],
      dialogPayment: false,
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      userCreditCardController: new UserCreditCardController(this.$resource),
      userController: new UserController(this.$resource),
      clientController: new ClientController(this.$resource),
      paymentController: new PaymentController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),
      begin_date: moment().subtract(5, 'days').format('YYYY-MM-DD'),
      end_date: new Date().toISOString().substr(0, 10),
      data: [],
      search: '',
      model: '',
      json_fields: {
        'Id transação': 'transaction_id',
        'Id reserva': 'vr_id',
        Cliente: 'client_name',
        Usuário: 'user_name',
        Pagamento: 'type',
        Status: 'status',
        'Valor Autorizado': 'valor_pre_autorizado',
        'Valor Capturado': 'total_value_charged',
        'Data Autorização': 'pre_authorization_date',
        'Data Captura': 'data_captura',
      },
      headers: [
        { text: 'ID Transação', value: 'transaction_id' },
        { text: 'ID Reserva', value: 'vr_id' },
        { text: 'Cliente', value: 'client_name' },
        { text: 'Usuário', value: 'user_name' },
        { text: 'Pagamento', value: 'type' },
        { text: 'Status', value: 'status' },
        { text: 'Valor Autorizado', value: 'valor_pre_autorizado' },
        { text: 'Valor Capturado', value: 'total_value_charged' },
        { text: 'Data Autorização', value: 'pre_authorization_date' },
        { text: 'Data Captura', value: 'data_captura' },
        { text: 'Ações', value: 'action' },
      ],
      vehicle_request_id: '',
      client_id: null,
      transaction_id: '',
      user: '',
      payment: '',
      status: '',
      observation: '',
      paymentValue: 0,
      totalValueCharged: 0,
      dialogPreAuthorization: false,
      preAuthorizationValue: '',
      refund_payment_modal: false,
      modal_begin: false,
      modal_end: false,
      dialogCancelAuthorization: false,
    };
  },
  methods: {
    async refundFinish() {
      this.refund_payment_modal = false;
      this.blockScreen = false;
      await this.getReport(this.begin_date, this.end_date);
    },
    filtrar() {
      this.getReport(this.begin_date, this.end_date);
    },
    openDialogPreAuthorization(transaction) {
      this.vehicle_request_id = transaction.vehicle_request.id;
      this.dialogPreAuthorization = true;
    },
    capturePreAuthorization() {
      this.paymentController
        .capturePreAuthorization(
          this.vehicle_request_id,
          this.preAuthorizationValue
        )
        .then((res) => {
          this.dialogPreAuthorization = false;
          this.getReport(this.begin_date, this.end_date);
        })
        .catch((e) => console.log(e));
    },
    capturarPagamento() {
      debugger
      this.paymentController
        .capturePayment(this.pagamento)
        .then((res) => this.cleanFormPayment())
        .catch((err) => {
          this.$awn.alert(err.message);
        });
    },
    cleanFormPayment() {
      this.pagamento = {};
      this.dialogPayment = false;
    },
    cancelarAutorizacao() {
      this.cancelAuthorization.clientId = localStorage.getItem('client_id');
      this.paymentController
        .cancelAuthorization(this.cancelAuthorization)
        .then((res) => this.cleanFormCancelAuthorization())
        .catch((e) => this.cleanFormCancelAuthorization());
    },
    cleanFormCancelAuthorization() {
      this.cancelAuthorization = {};
      this.dialogCancelAuthorization = false;
    },
    getCardByUser() {
      this.userCreditCardController
        .getAllByUserId(this.pagamento.userId, true)
        .then((res) => {
          this.creditCards = res;
        });
    },
    getUsersByClient() {
      this.users = [];
      this.userController
        .getActiveByClientId(this.pagamento.clientId)
        .then((res) => {
          res.rows.forEach((user) => {
            this.users.push({
              text: user.name,
              value: user.id,
            });
          });
        });
    },
    async openDialogPayment() {
      await Promise.all([
        this.clientController.getAllClients().then(
          (res) => {
            res.forEach((client) => {
              this.clients.push({
                text: client.name,
                value: client.id,
              });
            });
          },
          (err) => {
            console.log(err);
          }
        ),
        this.paymentController.getTransactionTypes().then( res => {
          this.transactionTypes = res.body.reduce((acc, el) => {
            acc.push({ value: el.id, text: el.name });
            return acc;
          }, []);
        }),
      ]);
      this.dialogPayment = true;
    },
    async openDialogCancelAuthorization() {
      this.dialogCancelAuthorization = true;
    },

    refundPayment(item) {
      this.transaction = item;
      this.refund_payment_modal = true;
    },

    async getReport(begin_date = null, end_date = null) {
      try {
        this.blockScreen = true;
        let response = await this.paymentController.report(
          begin_date,
          end_date
        );
        this.data = response.body;
      } catch (error) {
        this.$awn.success(error);
      } finally {
        this.blockScreen = false;
      }
    },

    validateObservationField() {
      return this.status === 'Estornado';
    },
  },
  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },
    formatType(paymentType) {
      if (paymentType === 'pre_authorized') {
        return 'Pré autorizado';
      } else if (paymentType === 'reservation') {
        return 'Reserva';
      } else if (paymentType === 'surplus_check_out') {
        return 'Valor excedente';
      }
    },
    formatStatus(status) {
      if (status === 'refund') {
        return 'Estornado';
      } else if (status === 'auto_cancel') {
        return 'Auto Cancelamento';
      } else if (status === 'pending') {
        return 'Pendente';
      } else if (status === 'paid') {
        return 'Pago';
      }
    },
  },
};
</script>
<style>
.payment-autocomplete .v-text-field__details {
  display: none;
}

.table-custom-vue {
  margin: 25px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
</style>
